/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 16:26:15
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-06 17:00:45
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/Tags/index.tsx
 */
import React from 'react';
import { Tag } from 'src/components/Antd';
import css from './css.less';
const Tags = (props) => {
  const { data = [], onClose, disabled, ...rest } = props;
  const handleOnClose = (item) => {
    onClose(item);
  };
  return data.map((search, index) => {
    const { value, invisible, label } = search;
    if (invisible) {
      return null;
    }
    return (
      <Tag
        key={value}
        className={css.searchList}
        color='#eeeeee'
        closable
        visible
        onClose={handleOnClose.bind(this, search)}
        disabled={disabled}
        {...rest}>
        {label}
      </Tag>
    );
  });
};
export default Tags;
